<template>
  <div class="ablive">
    <div v-if="omsType === warehousing" class="ablive-main">
      <div class="ablive_title">可能是全网唯一“真的官方验”的二手验机中心</div>
      <div class="ablive_box">
        <div class="music">
          <img
            src="https://pic2.zhuanstatic.com/zhuanzh/79c3f3e4-0a2b-4496-a552-46ba027891ac.gif"
          />
        </div>
        <span class="tips">验机直播中</span>
        <img
          class="ablive-arrow-icon"
          src="https://pic1.zhuanstatic.com/zhuanzh/d5fc8809-86b6-426e-9fa7-9410c6782cfb.png"
          alt=""
        />
      </div>
    </div>

    <div class="ablive-main-title">验机评估报告</div>
  </div>
</template>

<script>
  import { warehousing } from '../config'
  export default {
    props: {
      omsType: {
        type: Number,
        default: undefined,
      },
    },
    data() {
      return {
        warehousing,
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.$legoAreaExposure && this.$legoAreaExposure()
      })
    },
  }
</script>
<style lang="scss">
  .ablive {
    background-image: url(https://pic6.zhuanstatic.com/zhuanzh/9b9d2455-e04e-41ad-bcad-3a015dca652a.png);
    background-size: 100% 127px;
    background-repeat: no-repeat;
    // background: url(https://pic4.zhuanstatic.com/zhuanzh/f838a53b-5349-45f6-9017-c064cd6948d3.png)
    // no-repeat 100% 127px;
    border-top-right-radius: 36px;
    border-top-left-radius: 36px;
    font-size: 20px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #111;
    overflow: hidden;
    padding: 0 36px;
    .ablive-main {
      display: flex;
      justify-content: space-between;
      align-content: center;
      padding: 40px 0 0px;
      box-sizing: border-box;
      .ablive_title {
        display: flex;
        align-items: center;
      }
      .ablive_box {
        display: flex;
        align-items: center;
        .tips {
          color: #111;
        }
        .music {
          margin-right: 8px;
          img {
            height: 18px;
            width: 16px;
          }
        }
        .ablive-arrow-icon {
          margin-left: 6px;
          height: 18px;
          width: 10px;
        }
      }
    }

    .ablive-main-title {
      font-size: 54px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #111;
      line-height: 54px;
      margin-top: 36px;
    }
  }
</style>
